export default "__VITE_ASSET__3a$ecXxy__"